import { publicHref } from '../lib/publicUrls';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import ClassSchedule from '../components/ClassSchedule';
import SEO from '../components/SEO';
import { ScheduleNavigation, ScheduleHero, ScheduleMedia } from './SchedulePresentation';
import { TourClosing } from '../components/TourJourney';

const SchedulePage = () => (
  <main className="dv-class-pages" data-testid="schedule-page">
    <SEO
      title="Class Schedule"
      description="View the current Delta Valley Health Club weekly class schedule for Brentwood and Discovery Bay."
      keywords="Delta Valley class schedule, Brentwood fitness classes, Discovery Bay fitness classes, group exercise schedule"
    />
    <ScheduleHero title="Schedule" scheduleId="weekly-schedule" parent={{ label: 'Home', href: '/' }}
      secondary={{ label: 'Book a Tour', href: '/book-a-tour' }}
      facts={['Brentwood & Discovery Bay', 'Cardio, Mind-Body & Weight Training', 'Updated live']} media={
      <ScheduleMedia src="/images/facility/cardio-room.jpg" asset="F01" alt="Cardio floor and treadmills" caption="Cardio floor" />
    }>
      <p className="dv-size-lede text-lg md:text-xl">Find this week&apos;s classes, instructors, and club locations in one live schedule.</p>
    </ScheduleHero>
    <ScheduleNavigation current="/schedule" />
    <section className="dv-class-pages__schedule" id="weekly-schedule" aria-labelledby="weekly-schedule-title">
      <div className="dv-class-pages__schedule-heading">
        <div>
          <p className="dv-class-pages__eyebrow text-sm font-bold uppercase tracking-[0.2em]">Current weekly calendar</p>
          <h2 id="weekly-schedule-title" className="dv-size-heading text-3xl font-bold md:text-4xl">Classes at Delta Valley</h2>
          <p className="dv-size-body">Pick a day, then narrow by program, time of day, or instructor. Tap any class for details, or open the dedicated Cardio page for class descriptions.</p>
        </div>
        <Button asChild className="dv-class-pages__cardio-link"><Link to={publicHref("/schedule/cardio")}>View Cardio Classes</Link></Button>
      </div>
      <ClassSchedule />
    </section>
    <TourClosing />
  </main>
);

export default SchedulePage;
